angular.module('bmsApp.marketing').factory('CustomerGroupSvc', function (CRUDSvc, CUSTOMER_GROUP_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(CUSTOMER_GROUP_API.INDEX, params);
		},
		read: function (id) {
			return CRUDSvc.get(CUSTOMER_GROUP_API.READ + id);
		},
		create: function (data) {
			return CRUDSvc.create(CUSTOMER_GROUP_API.CREATE, data);
		},
		update: function (id, data) {
			return CRUDSvc.update(CUSTOMER_GROUP_API.UPDATE, id, data);
		},
		options: function (params) {
			return CRUDSvc.get(CUSTOMER_GROUP_API.OPTIONS, params);
		},
		remove: function (id) {
			return CRUDSvc.get(CUSTOMER_GROUP_API.DELETE + id);
		}
	};

}).constant('CUSTOMER_GROUP_API', {
	INDEX: 'api/marketing/customerGroups/index',
	READ: 'api/marketing/customerGroup/read/',
	CREATE: 'api/marketing/customerGroup/create',
	UPDATE: 'api/marketing/customerGroup/update',
	OPTIONS: 'api/customerGroup/options',
	DELETE: 'api/marketing/customerGroup/delete/'
});
